import { InfoCircleOutlined } from '@ant-design/icons';
import ConnectedPageModel from '@mm/state/model/ConnectedPageModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import {
  activeCompanySelector,
  companyAdminSelector,
} from '@mm/state/selectors/viewSelectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { PrimaryToolTip } from '../../../../../../../../common/components/PrimaryToolTip/PrimaryToolTip';
import './PromoCodeArea.pcss';

type Props = {
  page: ConnectedPageModel;
};

const PromoCodeArea = (props: Props) => {
  const { page } = props;
  const { redemption } = page;
  const isCompanyAdmin = useSelector(companyAdminSelector);
  const company = useSelector(activeCompanySelector);
  const { openConfirmDowngradePromoModal } = useModalActions();

  const openDowngradeModal = openConfirmDowngradePromoModal;

  if (redemption && !redemption.compsPro && company) {
    return (
      <div className="promo-code-area">
        <div className="promo-code-area__title">
          Promotion code:{' '}
          <span className="promo-code-area__code">{redemption.code}</span>
          {!redemption.disconnectAble && (
            <div className="promo-code-area__disclaimer">
              <PrimaryToolTip
                title="Promotion Rules"
                align="end"
                position="bottom"
                withoutLine
                anchorElement={
                  <InfoCircleOutlined className="promo-code-area__disabled-icon" />
                }
              >
                The code can be removed once every 6 months if facebook page has
                less than 500 contacts.
              </PrimaryToolTip>
            </div>
          )}
        </div>

        {redemption.disconnectAble && isCompanyAdmin && (
          <div
            className="promo-code-area__disconnect-link"
            onClick={() => openDowngradeModal({ page, companyId: company.id })}
          >
            Disconnect
          </div>
        )}
      </div>
    );
  }

  return null;
};
export default PromoCodeArea;
